import { render } from "./NameTH.vue?vue&type=template&id=ab4246e8"
import script from "./NameTH.vue?vue&type=script&lang=js"
export * from "./NameTH.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__